<template>
  <div class="admin-illustration" v-if="illustration">
    <navbar></navbar>
    <h2>Edit Illustration "{{illustration.Subject}}"</h2>

    <div class="row">
        <span class="col-md-6">
          <p></p>
          <h5>Subject</h5>
          <b-form-input v-model="illustration.Subject" type="text" placeholder="Subject" ></b-form-input>
          <p></p>
          <h5>Slug</h5>
          <b-form-input v-model="illustration.Slug" type="text" placeholder="Slug"></b-form-input>
          <p></p>
          <h5>Remarks</h5>
          <b-form-input v-model="illustration.Remarks" textarea placeholder="Remarks"></b-form-input>
        </span>
        <span class="col-md-6">
          <p></p>
          <h5>Shape</h5>
          <select class="form-control" v-model="illustration.ShapeId">
            <option v-for="s in shapes" :value="s.Key">{{s.Value}}</option>
          </select>
          <p></p>
          <h5>Composition Type</h5>
          <select class="form-control" v-model="illustration.CompositionTypeId">
            <option v-for="s in shapes" :value="s.Key">{{s.Value}}</option>
          </select>
        </span>
    </div>
    <div class="row">
      <span class="col-md-12">
        <p></p>
        <h5>Icon Classes</h5>
        <multiselect v-model="illustration.IconClasses.Items" tag-placeholder="Add this as new tag" placeholder="Search or add a tag" label="Value" track-by="Key" :options="iconclasses" :multiple="true" :taggable="true" @tag="addTag"></multiselect>
      </span>
    </div>
    <div class="row">
      <span class="col-md-12">
        <p></p>
        <b-button variant="primary" v-on:click="save()">Opslaan, Juffie</b-button> <b-button variant="secondary" v-on:click="cancel()">Annuleren</b-button>
      </span>
    </div>
  </div>
</template>

<script>

import navbar from '@/components/navbar.vue';
import Multiselect from 'vue-multiselect';

export default {
  name: 'admin-illustration',
  data () {
    return {
      illustration : null,
      sizes : [],
      shapes : [],
      compositiontypes : [],
      iconclasses : [],
      selectediconclasses : []
    }
  },
  methods: {
    // Load employee-data form webserivce
    loaddata: function () {
      var data = {
        Slug: this.$route.params.slug
      };
      this.$http.post('x/pIllustrationDetails', data).then(function(response) { this.illustration = response.data.Illustration; });
      this.$http.post('pLookup', {"LookupName": "Size"}).then(function(response) { this.sizes = response.data; });
      this.$http.post('pLookup', {"LookupName": "Shape"}).then(function(response) { this.shapes = response.data; });
      this.$http.post('pLookup', {"LookupName": "CompositionType"}).then(function(response) { this.compositiontypes = response.data; });
      this.$http.post('pLookup', {"LookupName": "Iconclass"}).then(function(response) { this.iconclasses = response.data; });
    },
    addTag (newTag) {
      const tag = {
        Key: newTag,
        Value: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
      }
      this.illustration.IconClasses.Items.push(tag)
      this.selectediconclasses.push(tag)
    },
    save: function () {
      this.$http.post('x/pIllustrationSave', {"Illustration" : this.illustration}).then(function(response) {  this.$router.push({ name: "AdminIllustrations" }); });
    }
    ,
    cancel: function () {
        this.$router.push({ name: "AdminIllustrations" });
    }
  },
  components: {
    navbar,
    Multiselect
  },
  created: function() {
					this.loaddata();
        }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// admin-illustration.vue?59a9aab9